import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PreCamp from "./preCamp";
import { documentUploadUrl } from "services/redux/fileUpload/action";
import {
  getPreCampQues,
  postPreCampQues,
  } from "services/redux/brandActivtion/conductCamp/action"

const mapStateToProps = (state) => ({
    quesList: state.ConductCampReducer.questionnaireList,
    quesSaveRes: state.ConductCampReducer.questionnaireSaveRes,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    getPreCampQues,
    postPreCampQues,
    documentUploadUrl,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PreCamp);
